// JUUN Wellness — site interactions (vanilla JS, no build step)
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initGallery();
    initPacks();
    initQty();
    initTestimonials();
    initFormulaAccordion();
    initCarousels();
  });

  function initCarousels() {
    document.querySelectorAll(".jn-carousel").forEach(function (car) {
      var track = car.querySelector("[data-carousel-track]");
      if (!track) return;
      var count = track.children.length;
      if (count < 2) return;

      var prevBtn = car.querySelector(".jn-carousel__arrow--prev");
      var nextBtn = car.querySelector(".jn-carousel__arrow--next");
      var dotsWrap = car.nextElementSibling;
      if (!dotsWrap || !dotsWrap.hasAttribute("data-carousel-dots")) dotsWrap = null;

      var dots = [];
      if (dotsWrap) {
        for (var i = 0; i < count; i++) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "jn-carousel__dot";
          dot.setAttribute("aria-label", "Ver elemento " + (i + 1));
          (function (idx) {
            dot.addEventListener("click", function () { scrollToIndex(idx); });
          })(i);
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
      }

      function currentIndex() {
        var w = track.clientWidth || 1;
        return Math.round(track.scrollLeft / w);
      }
      function updateDots() {
        var idx = currentIndex();
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
      }
      function scrollToIndex(i) {
        var clamped = ((i % count) + count) % count;
        track.scrollTo({ left: clamped * track.clientWidth, behavior: "smooth" });
      }

      if (prevBtn) prevBtn.addEventListener("click", function () { scrollToIndex(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { scrollToIndex(currentIndex() + 1); });

      var rafId = 0;
      track.addEventListener("scroll", function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () { rafId = 0; updateDots(); });
      }, { passive: true });

      var resizeTimer = 0;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          track.scrollLeft = currentIndex() * track.clientWidth;
        }, 150);
      });

      updateDots();
    });
  }

  function initFormulaAccordion() {
    var items = document.querySelectorAll(".jn-formula__item");
    items.forEach(function (item) {
      var btn = item.querySelector(".jn-formula__item-head");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        items.forEach(function (i) { i.classList.remove("is-open"); });
        if (!isOpen) item.classList.add("is-open");
      });
    });
  }

  function initHeader() {
    var header = document.querySelector(".jn-header");
    var menuBtn = document.querySelector(".jn-header__menu-btn");
    var mobileNav = document.querySelector(".jn-header__mobile-nav");
    if (header) {
      window.addEventListener("scroll", function () {
        header.classList.toggle("is-scrolled", window.scrollY > 8);
      });
    }
    if (menuBtn && mobileNav) {
      menuBtn.addEventListener("click", function () {
        mobileNav.classList.toggle("is-open");
      });
    }
  }

  function initGallery() {
    document.querySelectorAll(".jn-gallery").forEach(function (gallery) {
      var main = gallery.querySelector(".jn-gallery__main img");
      var thumbs = gallery.querySelectorAll(".jn-gallery__thumbs img");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!main) return;
          main.src = thumb.getAttribute("data-full") || thumb.src;
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  function fmtMXN(n) {
    return "$" + Number(n).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MXN";
  }

  function initPacks() {
    document.querySelectorAll(".jn-product").forEach(function (root) {
      var packButtons = root.querySelectorAll(".jn-pack");
      var variantInput = root.querySelector(".product-variant-id");
      var qtyInput = root.querySelector(".jn-qty input");
      var totalPriceEl = root.querySelector(".jn-buy-total__price");
      var totalMetaEl = root.querySelector(".jn-buy-total__meta");

      function recompute() {
        var active = root.querySelector(".jn-pack.is-active");
        if (!active) return;
        var price = parseFloat(active.getAttribute("data-price") || "0");
        var qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
        if (totalPriceEl) totalPriceEl.textContent = fmtMXN(price * qty);
      }

      packButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          packButtons.forEach(function (b) { b.classList.remove("is-active"); });
          btn.classList.add("is-active");
          if (variantInput) variantInput.value = btn.getAttribute("data-variant-id");
          if (totalMetaEl) totalMetaEl.textContent = btn.getAttribute("data-meta") || "";
          recompute();
        });
      });

      if (qtyInput) {
        qtyInput.addEventListener("input", recompute);
      }
      recompute();
    });
  }

  function initQty() {
    document.querySelectorAll(".jn-qty").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector('[data-step="-1"]');
      var plus = wrap.querySelector('[data-step="1"]');
      function clamp(v) {
        var min = parseInt(input.min || "1", 10);
        var max = parseInt(input.max || "20", 10);
        return Math.max(min, Math.min(max, v));
      }
      if (minus) minus.addEventListener("click", function () {
        input.value = clamp((parseInt(input.value || "1", 10) || 1) - 1);
        input.dispatchEvent(new Event("input"));
      });
      if (plus) plus.addEventListener("click", function () {
        input.value = clamp((parseInt(input.value || "1", 10) || 1) + 1);
        input.dispatchEvent(new Event("input"));
      });
    });
  }

  function initTestimonials() {
    var players = [];

    function updateBadge(entry) {
      if (!entry.badge) return;
      entry.badge.textContent = entry.selected ? "Click to mute" : "Click to unmute";
    }

    function deselect(entry, keepPlayingIfHovered) {
      if (!entry.selected) return;
      entry.selected = false;
      entry.video.muted = true;
      updateBadge(entry);
      if (!keepPlayingIfHovered || !entry.hovered) {
        entry.video.pause();
        try { entry.video.currentTime = 0; } catch (e) {}
        entry.card.classList.remove("is-playing");
      }
    }

    document.querySelectorAll(".jn-testi").forEach(function (card) {
      var video = card.querySelector("video");
      if (!video) return;
      var entry = {
        card: card, video: video, hovered: false, selected: false,
        badge: card.querySelector(".jn-testi__audio")
      };
      players.push(entry);

      card.addEventListener("mouseenter", function () {
        entry.hovered = true;
        if (entry.selected) return;
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add("is-playing");
      });
      card.addEventListener("mouseleave", function () {
        entry.hovered = false;
        if (entry.selected) return;
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
        card.classList.remove("is-playing");
      });
      card.addEventListener("click", function () {
        if (entry.selected) {
          // Solo silencia — si el mouse sigue encima, el preview mudo continúa.
          deselect(entry, true);
        } else {
          // Solo un video puede tener audio a la vez: silencia cualquier otro seleccionado.
          players.forEach(function (other) { if (other !== entry) deselect(other, true); });
          entry.selected = true;
          video.muted = false;
          video.volume = 1;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add("is-playing");
          updateBadge(entry);
        }
      });
    });
  }
})();
